export default "__VITE_ASSET__Dcsy56Tz__"